/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Dashboard_Unconfirmed_MembersInputs */

const en_admin_dashboard_unconfirmed_members = /** @type {(inputs: Admin_Dashboard_Unconfirmed_MembersInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Member Unconfirmed`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Members Unconfirmed`);
	return /** @type {LocalizedString} */ ("admin.dashboard.unconfirmed_members");
};

const de_admin_dashboard_unconfirmed_members = /** @type {(inputs: Admin_Dashboard_Unconfirmed_MembersInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("de", i?.count, {});return /** @type {LocalizedString} */ (`Unbestätigte Mitglieder`)
};

const es_admin_dashboard_unconfirmed_members = /** @type {(inputs: Admin_Dashboard_Unconfirmed_MembersInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("es", i?.count, {});return /** @type {LocalizedString} */ (`Miembros no confirmados`)
};

const fr_admin_dashboard_unconfirmed_members = /** @type {(inputs: Admin_Dashboard_Unconfirmed_MembersInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("fr", i?.count, {});return /** @type {LocalizedString} */ (`Membres non confirmés`)
};

const it_admin_dashboard_unconfirmed_members = /** @type {(inputs: Admin_Dashboard_Unconfirmed_MembersInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("it", i?.count, {});return /** @type {LocalizedString} */ (`Membri non confermati`)
};

const pt_br2_admin_dashboard_unconfirmed_members = /** @type {(inputs: Admin_Dashboard_Unconfirmed_MembersInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("pt-BR", i?.count, {});return /** @type {LocalizedString} */ (`membros não confirmados`)
};

const pl_admin_dashboard_unconfirmed_members = /** @type {(inputs: Admin_Dashboard_Unconfirmed_MembersInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("pl", i?.count, {});return /** @type {LocalizedString} */ (`Niepotwierdzeni członkowie`)
};

const hu_admin_dashboard_unconfirmed_members = /** @type {(inputs: Admin_Dashboard_Unconfirmed_MembersInputs) => LocalizedString} */ (i) => {
	const countPlural = registry.plural("hu", i?.count, {});return /** @type {LocalizedString} */ (`Meg nem erősített tagok`)
};

/** @type {(inputs: Admin_Dashboard_Unconfirmed_MembersInputs) => LocalizedString} */
const ro_admin_dashboard_unconfirmed_members = en_admin_dashboard_unconfirmed_members;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Member Unconfirmed" |
* | "other" | "Members Unconfirmed" |
*
* @param {Admin_Dashboard_Unconfirmed_MembersInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_unconfirmed_members = /** @type {((inputs: Admin_Dashboard_Unconfirmed_MembersInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Unconfirmed_MembersInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_unconfirmed_members(inputs)
	if (locale === "de") return de_admin_dashboard_unconfirmed_members(inputs)
	if (locale === "es") return es_admin_dashboard_unconfirmed_members(inputs)
	if (locale === "fr") return fr_admin_dashboard_unconfirmed_members(inputs)
	if (locale === "it") return it_admin_dashboard_unconfirmed_members(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_unconfirmed_members(inputs)
	if (locale === "pl") return pl_admin_dashboard_unconfirmed_members(inputs)
	if (locale === "hu") return hu_admin_dashboard_unconfirmed_members(inputs)
	return ro_admin_dashboard_unconfirmed_members(inputs)
});
export { admin_dashboard_unconfirmed_members as "admin.dashboard.unconfirmed_members" }